import { inject, type Component, type InjectionKey } from 'vue';
import type { NotificationVariant } from './Notification.vue';

export type NotificationOptions = {
  title: string | JSX.Element | Component;
  variant: NotificationVariant;
  group?: string;
  duration?: number;
  onClose?: () => void;
};

export const notifyKey = Symbol('jk/notify') as InjectionKey<
  (notification: NotificationOptions) => {
    dismiss: () => void;
  }
>;

export const useNotify = () => inject(notifyKey);
